import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class SubdomainRoutingService {
  private apiUrl = environment.apiBaseUrl; 
  constructor(private http: HttpClient) { }

  getSubdomain(): string {
    const host = window.location.hostname;
    const parts = host.split('.');
    if (parts.length > 1) {
      return parts[0];
    }
    return '';
  }

  verifyTenant() {
    return this.http.get<{ isSuccess: boolean; data: string[] }>(
      `${this.apiUrl}/get-all-Lessor-subdomains`
    );
  }
}
